<!-- Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/ -->

@for (param of params; track identity(param)) {
  @if (value == param.value) {
    <div class="wrapper">
      <ng-container *ngTemplateOutlet="param.innerTemplate"></ng-container>
    </div>
  }
}
